import React from 'react'
import { i18nTranslate } from 'src/utils'
import { Icons } from 'src/views/components'
import './styles.scss'

const AuthorizedSubscriptionLimitInfo = ({
  titleKey = 'cartCreateNewSubscriptionComponent.addToSubscription.authorizationLimitTitle',
  defaultTitle = 'Your recurring subscription amount is changing',
  infoKey = 'cartCreateNewSubscriptionComponent.addToSubscription.authorizationLimitInfo',
  defaultInfo = 'To add these items, you’ll need to raise your payment authorization limit.',
}) => {
  const authorizationLimitTitle = i18nTranslate(titleKey, defaultTitle)
  const authorizationLimitInfo = i18nTranslate(infoKey, defaultInfo)

  return (
    <div className="authorization-limit-info-wrapper">
      <div className="authorization-limit-title-wrapper">
        <span className="recurring-modal-icon">
          <Icons
            name="product-icon"
            icontype="danger-warning"
            width="24px"
            height="24px"
            color="#ED7219"
          />
        </span>
        <h5 className="authorization-limit-title">{authorizationLimitTitle}</h5>
      </div>
      <p className="authorization-limit-info">{authorizationLimitInfo}</p>
    </div>
  )
}

export { AuthorizedSubscriptionLimitInfo }
export default AuthorizedSubscriptionLimitInfo
